import { cn } from "@simble/shared/lib/cn";
import React from "react";
import Footer from "../components/footer";

type Actions = {
  goBack?: (() => void) | number;
  close?: (() => void) | number;
};

type PageLayoutProps = {
  header?: React.ReactNode;
  children: React.ReactNode;
  container?: "fluid" | "fixed";
  className?: string;
  actions?: Actions;
  stickyBottomContent?: React.ReactNode;
};

const PageLayout = React.memo<PageLayoutProps>(({ header, className, children, container = "fixed", stickyBottomContent = <Footer /> }) => (
  <div className="min-h-screen">
    {header}
    <div className="flex flex-1 flex-col">
      <main className="flex flex-1 flex-col">
        <div
          className={cn(
            "mx-auto flex min-h-[calc(100vh-250px)] w-full flex-1 flex-col",
            container === "fluid" ? "max-w-full" : "max-w-[1028px]",
            className
          )}
        >
          {children}
        </div>
      </main>
      {stickyBottomContent}
    </div>
  </div>
));

export default PageLayout;
